import React from "react";
import Masonry from "react-masonry-component";
import { RichText } from "prismic-reactjs";

import {
  Box,
  LongGridCard,
  MediumGridCard,
  SmallGridCard,
  TallGridCard
} from "src/components";

import serializer from "src/utils/serializer";
import linkResolver from "src/utils/linkResolver";

const masonryOptions = {
  transitionDuration: 0,
  columnWidth: ".masonry-sizer"
};

const Grid = ({ tiles }) => (
  <Box>
    <div
      css={`
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        overflow: hidden;
        background: ${props => props.theme.colors.brand.yellow};
      `}
    >
      <Masonry
        options={masonryOptions} // default {}
        style={{ width: "100%" }}
      >
        {tiles.map((tile, index) => {
          if (tile.size === "Small") {
            return (
              <MediumGridCard
                children={
                  tile.text &&
                  RichText.render(tile.text, linkResolver, serializer)
                }
                icon={tile.icon}
                label={tile.label}
                link={tile.tile_link}
                fontSize={tile.font_size}
                key={"gridItem" + index}
                color={tile.color.toLowerCase()}
                image={tile.image && tile.image.url && tile.image}
                className="masonry-sizer"
              />
            );
          }
          if (tile.size === "Tall") {
            return (
              <TallGridCard
                children={
                  tile.text &&
                  RichText.render(tile.text, linkResolver, serializer)
                }
                icon={tile.icon}
                label={tile.label}
                fontSize={tile.font_size}
                link={tile.tile_link}
                image={tile.image && tile.image.url && tile.image}
                key={"gridItem" + index}
                color={tile.color.toLowerCase()}
              />
            );
          }
          if (tile.size === "Long") {
            return (
              <LongGridCard
                children={
                  tile.text &&
                  RichText.render(tile.text, linkResolver, serializer)
                }
                icon={tile.icon}
                label={tile.label}
                fontSize={tile.font_size}
                link={tile.tile_link}
                image={tile.image && tile.image.url && tile.image}
                key={"gridItem" + index}
                color={tile.color.toLowerCase()}
              />
            );
          }
          if (!tile.size) {
            return null;
          }
        })}
      </Masonry>
    </div>
  </Box>
);

export default Grid;
